const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the description editor component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('descriptionEditor', ['Authorization', 'FroalaOptions', function (Authorization, FroalaOptions) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        content: '=',
        onBlur: '&?',
        focusValue: '@?',
        focusVariable: '=?',
        collapse: '=?',
        title: '=?',
        simple: '=?'
      },
      template: require('../../../templates/directives/cms/description-editor.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        self.collapse = $scope.collapse;
        self.simpleMode = $scope.simple ? $scope.simple : false;

        $scope.content = $scope.content || {};
        self.froalaLocalOptions = {
          height: 300,
          imageDefaultWidth: 600,
          toolbarButtons: [ 'bold', 'italic', 'underline', 'fontSize', 'color', 'emoticons', 'align', 'outdent', 'indent','formatOL', 'formatUL',  'insertLink', 'insertImage','customClear', 'undo', 'redo'],
          imageUploadParams: {
            token: 'AuthToken token=' + Authorization.getAuthToken().authtoken
          },
          imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
          fontSizeDefaultSelection: 14,
          events: {
            blur: function() {
              if ($scope.onBlur) {
                $scope.onBlur({type: 'description'});
              }
            },
            focus: function() {
              if ($scope.focusValue) {
                $scope.focusVariable = $scope.focusValue;
              }
              $scope.$apply();
            }
          }
        };

        const checkSimpleMode = () => {
          if($scope.simple){
            self.froalaLocalOptions.toolbarButtons = [ 'bold', 'italic', 'underline', 'strikethrough', 'formatUL', 'formatOL', 'insertLink', 'undo', 'redo' ];
            self.froalaLocalOptions.pasteAllowedStyleProps = ['font-weight','text-decoration',];
          }
        };
        checkSimpleMode();

        if ($scope.content && $scope.content.vendor && $scope.content.vendor === 'linkedin_learning') {
          delete self.froalaLocalOptions.height;
        }

        self.froalaOptions = Object.assign({}, FroalaOptions, self.froalaLocalOptions);
      }],
      controllerAs: 'description'
    };
  }]);

